function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "security-bg_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h866v1010H0z"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#security-bg_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "transparent",
  d: "M0 0h866v1010H0z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 19062",
  d: "M802.978 178.556L438.217 50.8a17.614 17.614 0 00-10.469 0L62.986 178.556A18.875 18.875 0 0050 196.719v403.074c0 167.668 245.922 316.794 377.6 359.374a17.895 17.895 0 0010.8 0C570.078 916.548 816 767.459 816 599.791V196.719a18.9 18.9 0 00-13.022-18.163z",
  fill: "#0d0d12"
}));

var SvgSecurityBg = function SvgSecurityBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 866,
    height: 1010
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4NjYiIGhlaWdodD0iMTAxMCI+PGRlZnM+PGNsaXBQYXRoIGlkPSJhIj48cGF0aCBkPSJNMCAwaDg2NnYxMDEwSDB6Ii8+PC9jbGlwUGF0aD48L2RlZnM+PGcgY2xpcC1wYXRoPSJ1cmwoI2EpIj48cGF0aCBmaWxsPSJ0cmFuc3BhcmVudCIgZD0iTTAgMGg4NjZ2MTAxMEgweiIvPjxwYXRoIGRhdGEtbmFtZT0iUGF0aCAxOTA2MiIgZD0iTTgwMi45NzggMTc4LjU1Nkw0MzguMjE3IDUwLjhhMTcuNjE0IDE3LjYxNCAwIDAwLTEwLjQ2OSAwTDYyLjk4NiAxNzguNTU2QTE4Ljg3NSAxOC44NzUgMCAwMDUwIDE5Ni43MTl2NDAzLjA3NGMwIDE2Ny42NjggMjQ1LjkyMiAzMTYuNzk0IDM3Ny42IDM1OS4zNzRhMTcuODk1IDE3Ljg5NSAwIDAwMTAuOCAwQzU3MC4wNzggOTE2LjU0OCA4MTYgNzY3LjQ1OSA4MTYgNTk5Ljc5MVYxOTYuNzE5YTE4LjkgMTguOSAwIDAwLTEzLjAyMi0xOC4xNjN6IiBmaWxsPSIjMGQwZDEyIi8+PC9nPjwvc3ZnPg==";
export { SvgSecurityBg as ReactComponent };